import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const LegalAdviceIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="m4.1 28 5.3-17.6L15.1 28M34.9 28.3l5.3-18.4 5.6 18.4"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="M25.2 11.4c-2.4 0-4.4-2-4.4-4.4v-.5c-.9-.6-1.8-1-2.9-1-2.9 0-5.5 2.4-5.5 2.4-.2.2-.4.3-.6.4-.5 1-1.5 1.6-2.6 1.6L9 10c-.8 0-1.5-.4-2-1s-.8-1.3-.8-2.1c.1-1.6 1.4-2.8 2.9-2.8h.1c.4 0 .8.1 1.1.3 1.8-1.4 4.6-2.8 7.5-2.8 1.8 0 3.5.5 5.1 1.6.7-.4 1.4-.6 2.2-.6.9 0 1.7.3 2.4.7 1.6-1.2 3.3-1.7 5.2-1.7 3 0 5.6 1.5 6.9 2.4.2 0 .3 0 .4.1h.5c.8 0 1.5.4 2 1s.8 1.3.8 2.1c-.1 1.6-1.4 2.8-2.9 2.8h-.1c-.8 0-1.5-.4-2-1-.5-.5-.7-1.2-.8-1.8-1.1-.8-2.7-1.6-4.5-1.6-1.2 0-2.2.4-3.2 1.2l-.1.1v.2c0 2.3-2 4.3-4.5 4.3z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M32.9 2.5c2.7 0 5.1 1.4 6.3 2.2.2.1.3.3.4.5.2-.1.5-.2.8-.2h.1c1.1.1 1.9 1 1.8 2-.1 1-.9 1.8-1.9 1.8h-.1c-1.1-.1-1.9-1-1.8-2 0-.1 0-.3.1-.4-.1 0-.3-.1-.4-.2-1.2-.8-3.1-1.9-5.1-1.9-1.2 0-2.5.4-3.8 1.4-.2.1-.4.2-.6.2.1.3.1.6.1.9 0 1.9-1.5 3.4-3.4 3.4S22 8.7 22 6.8c0-.3.1-.6.1-.9-.1 0-.2-.1-.2-.1-1.2-1-2.5-1.4-3.8-1.4-3.3 0-6.2 2.6-6.2 2.7-.2.2-.4.3-.7.3-.3.9-1.1 1.6-2 1.6h-.1C8 8.9 7.2 8 7.2 6.9c.1-1 .9-1.8 1.9-1.8h.1c.5 0 .9.2 1.3.6 1.5-1.4 4.4-3.1 7.4-3.1 1.7 0 3.4.5 5 1.8.6-.5 1.4-.9 2.2-.9 1 0 1.8.4 2.5 1 .1-.1.1-.2.2-.2 1.8-1.3 3.5-1.8 5.1-1.8m0-2c-1.9 0-3.7.5-5.3 1.6-.7-.4-1.5-.5-2.4-.5-.7 0-1.5.2-2.2.5-1.6-1-3.3-1.5-5.1-1.5-2.9 0-5.7 1.3-7.6 2.7-.3-.1-.6-.2-.9-.2h-.2c-2.1 0-3.8 1.6-3.9 3.7C5.1 9 6.8 10.8 9 11h.2c1.4 0 2.6-.7 3.3-1.9.2-.1.4-.3.6-.4.6-.6 2.8-2.1 4.8-2.1.7 0 1.3.2 1.9.5 0 3 2.5 5.4 5.4 5.4 2.9 0 5.3-2.3 5.4-5.2.7-.5 1.4-.7 2.3-.7 1.4 0 2.7.7 3.6 1.2.3 1.8 1.8 3.1 3.7 3.2h.2c2.1 0 3.8-1.6 3.9-3.7.1-2.2-1.6-4-3.7-4.1H40.3C38.9 2.1 36.1.5 32.9.5z"
        fill="#000000"
        className={styles.defaultColor}
      />
      <path
        d="M32.6 44.6h-1.8c-.3-2-1.8-3.7-3.8-4.3V18.6c1.1-.6 1.5-1.6 1.5-2.9h-7.1c0 1.2.5 1.9 1.5 2.9v21.8c-1.8.7-3.1 2.3-3.4 4.2H17c-2.2 0-3.9 1.7-3.9 3.7h23.5c-.1-2.1-1.8-3.7-4-3.7z"
        fill="#ffffff"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        stroke="#000000"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M32.2 26.8c-.8 0-1.4.7-1.3 1.5.7 4.6 4.7 8.2 9.4 8.2s8.7-3.6 9.4-8.2c.1-.8-.5-1.5-1.3-1.5H32.2zM1.4 26.4c-.8 0-1.4.7-1.3 1.4.7 4.7 4.7 8.2 9.4 8.2s8.7-3.6 9.4-8.2c.1-.8-.5-1.4-1.3-1.4H1.4z"
        fill="#E81C30"
        className={styles.accentColor}
      />
    </Icon>
  )
}
